
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { SharedService } from '@app/services/shared.service';
import {MarketOrderDetails, OrderPagedResponse} from '@app/marketplace/orders/_models/order.interface';
import {ContactPagedResponse} from '@app/marketplace/checkout/_models/contact.model';
import {ResponseBaseModel} from '@app/marketplace/core/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService extends SharedService {

  constructor(
    httpCLient: HttpClient
  ) {
    super(httpCLient);
  }

  ListContacts(payload: any) {
    //const url = 'api/v3/contact/search';
    const url = 'api/market/contact/search';
    return this.post<ContactPagedResponse>(url, payload);
  }

  AddContact(payload: any) {
    //const url = 'api/v3/contact/push';
    const url = 'api/market/contact/push';
    return this.post<ResponseBaseModel>(url, payload);
  }

  UpdateContact(payload: any) {
    //const url = 'api/v3/contact/update';
    const url = 'api/market/contact/update';
    return this.post<ResponseBaseModel>(url, payload);
  }

  RemoveContact(codes: string[]) {
    //const url = 'api/v3/contact/remove';
    const url = 'api/market/contact/remove';
    return this.post<ResponseBaseModel>(url, codes);
  }
}
